import { render, staticRenderFns } from "./IconCloseRed.vue?vue&type=template&id=b83f153a&scoped=true&"
var script = {}
import style0 from "./IconCloseRed.vue?vue&type=style&index=0&id=b83f153a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83f153a",
  null
  
)

export default component.exports